export default {
    GET_SETTING_PAYMENT: '[SETTING] GET_SETTING_PAYMENT',
    GET_SETTING_SHIPPING: '[SETTING] GET_SETTING_SHIPPING',
    GET_SETTING_SYNC: '[SETTING] GET_SETTING_SYNC',
    GET_SETTING_PRINTER: '[SETTING] GET_SETTING_PRINTER',
    GET_SETTING_GENERAL: '[SETTING] GET_SETTING_GENERAL',
}



// WEBPACK FOOTER //
// ./src/view/constant/settings/SettingListConstant.js